// extracted by mini-css-extract-plugin
export default {"header":"Header-common-module__header___3Lnw4","svgContainer":"Header-common-module__svgContainer___1MKj_"};